import { Outlet } from "react-router-dom";

function AssetsMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default AssetsMain;